import * as _m from '@/models';
import InfiniteScroll from 'react-infinite-scroller';
import { Header as ChannelPostHeader } from '@/components/channel_post/Header';
import { Information } from '@/components/channel_post/Information';
import { Body } from '@/components/channel_post/Body';
import { RelCreators } from '@/components/channel_post/RelCreators';
import { useChannelPosts } from '@/hooks/api/useChannelPosts';
import { Description } from '@/components/channel_post/Description';

type Props = {
  cid: string;
};
export const ChannelPostList = ({ cid }: Props) => {
  // const { data, isLoading, isFetching, fetchNextPage, refetch } = useChannelPosts(cid);

  const { infiniteQuery } = useChannelPosts(cid);
  const { data, isLoading, isFetching, fetchNextPage, refetch } = infiniteQuery('newest');

  return (
    <section className="posts">
      {data && (
        <InfiniteScroll
          loadMore={() => {
            !isFetching && fetchNextPage();
          }}
          hasMore={data.pages[data.pages.length - 1].has_next}
          className={'results'}
        >
          {data.pages.map((resp) =>
            resp.channel_posts.map((channelPost) => (
              <PostElement key={`${channelPost.id}`} channel_post={channelPost} />
            ))
          )}
        </InfiniteScroll>
      )}
    </section>
  );
};

type PostElementProps = {
  channel_post: _m.ChannelPost;
};
const PostElement = ({ channel_post }: PostElementProps) => {
  return (
    <div className={'post'}>
      <ChannelPostHeader channel_post={channel_post} />
      <Information channel_post={channel_post} />
      <Body playable={false} channel_post={channel_post} />
      <RelCreators channel_post={channel_post} />
      <Description channel_post={channel_post} />
    </div>
  );
};
